import request from '@/utils/requestV2'
const qs = require('qs')
/**
 * 分页查询客户留言信息
 * @param {Object} data
 * @returns
 */
export function getWxMessagePage (data) {
  return request.post('/ooh-sys/v1/website/getWxMessagePage', qs.stringify(data))
}
